import { useEffect, useId, useMemo, useRef } from "react";
import classNames from "classnames";
import { useState } from "react";

function HintArrow({ className }) {
  const id = useId();
  const ref = useRef();

  const [visible, setVisible] = useState(false);

  /**
   * An interaction observer object that allows us to monitor any interaction between the arrow's
   * div, and the viewport (visible area). It will make the arrow visible when it intersects the
   * viewport, with a specified margin (margin is w.r.t. the viewport, so it's negative, as we want
   * the arrow to be _inside_ the visible area by some pixels before making it visible.)
   */
  const observer = useMemo(
    () =>
      new IntersectionObserver(
        (data) => {
          if (data[0].isIntersecting) setVisible(true);
        },
        {
          root: null,
          threshold: [0.9, 1],
          rootMargin: "0px 5px 0px 0px",
        }
      ),
    []
  );

  /**
   * This is a callback to begin the observation of the div when the component first renders. As the
   * `observer` object is memoized, it won't change across renders.
   */
  useEffect(() => {
    observer.observe(ref.current);
  }, [observer]);

  /**
   * This is used to stop the interaction monitoring after the first animation has been triggered.
   */
  if (visible) {
    observer.disconnect();
  }

  return (
    <div
      className={classNames("flex flex-row w-max", className, {
        invisible: !visible,
      })}
      ref={ref}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="16">
        <circle
          cx="3"
          cy="8"
          r="3"
          className={classNames("arrow-circle", {
            "arrow-circle-animation": visible,
          })}
        />
      </svg>
      <div
        className={classNames("w-full h-full hint-arrow", {
          "hint-arrow-animation": visible,
        })}
        style={{ clipPath: `url(#${id})` }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="134" height="16">
          <clipPath id={id}>
            <path
              d="M13.951 7.001a1 1 0 0 0 0 2v-2Zm125.707 1.707a.999.999 0 0 0 0-1.414L133.294.93a1 1 0 0 0-1.414 1.414l5.657 5.657-5.657 5.657a.999.999 0 1 0 1.414 1.414l6.364-6.364Zm-125.707.293h125v-2h-125v2Z"
              transform="translate(-6 0)"
            />
          </clipPath>
        </svg>
      </div>
    </div>
  );
}

export default HintArrow;
